export default "__VITE_ASSET__BKGa7tWM__"